import useAuth from '../hooks/useAuth'
import { jwtDecode } from 'jwt-decode'
import axios from 'axios'
import { useEffect } from 'react'
import { AuthContextProps } from '../context/AuthProvider'
import { useNavigate, useLocation } from 'react-router-dom'

const RequireAuth = ({
  permission,
  children,
}: {
  permission: string
  children: React.ReactNode
}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { dispatch } = useAuth() as AuthContextProps

  const checkTokenExpiration = async () => {
    let accessToken = localStorage.getItem('tou-token')

    if (!accessToken) {
      return navigate('/')
    }

    const expirationTime = decodeToken(accessToken)

    if (expirationTime) {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/auth/refresh`,

          {},
          {
            withCredentials: true,
          }
        )

        const newAccessToken = response.data
        localStorage.setItem('tou-token', newAccessToken)
        dispatch({ type: 'SET_ACCESS_TOKEN', payload: newAccessToken })
      } catch (error) {
        localStorage.setItem('tou-token', '')
        console.error('Refresh token request failed:', error)
        navigate('/')
      }
    } else {
      dispatch({ type: 'SET_ACCESS_TOKEN', payload: accessToken })
    }
  }

  useEffect(() => {
    // 라우트 변경 시마다 Access Token이 유효한지 다시 확인
    checkTokenExpiration()
  }, [location.pathname, navigate])

  return <>{children}</>
}

const decodeToken = (token: string) => {
  const decoded = jwtDecode(token)
  return decoded.exp !== undefined && decoded.exp < Date.now() / 1000
}

export const RequireAuthWrapper = ({
  permission,
  children,
}: {
  permission: string
  children: React.ReactNode
}) => {
  return <RequireAuth permission={permission}>{children}</RequireAuth>
}
